module.exports = __webpack_public_path__ + "img/202502_08.ee5366c9.jpg";